import React from 'react';
import { Card } from 'primereact/card';
import AppOverView from '../../assets/img/app_overview.png';
import TopBar from '../common/Topbar.js';
import FooterMenu from '../common/FooterMenu';
import { dictionary } from '../../dictionary';
import MobileOverlay from './MobileOverlay';

const MainPage = () => {
  const steps = [
    { title: dictionary.main_page_list_item_title1, text: dictionary.main_page_list_item1, icon: 'pi-sign-in' },
    { title: dictionary.main_page_list_item_title2, text: dictionary.main_page_list_item2, icon: 'pi-plus-circle' },
    { title: dictionary.main_page_list_item_title3, text: dictionary.main_page_list_item3, icon: 'pi-pencil' },
    { title: dictionary.main_page_list_item_title4, text: dictionary.main_page_list_item4, icon: 'pi-file-export' },
  ];
  return (
    <div className="main-page">
      <MobileOverlay />
      <TopBar />
      <div className="row">
        <div className="col">
          <h1>{dictionary.main_page_title}</h1>
          <h2>{dictionary.main_page_subtitle}</h2>
        </div>
        <div className="col">
          <div className="img-wrapper">
            <img src={AppOverView} alt="app-overview" />
          </div>
        </div>
      </div>
      <div className="steps-grid">
        {steps.map((step, index) => (
          <Card key={index} className="step-card">
            <div className="icon-wrapper">
              <i className={`pi ${step.icon}`}></i>
            </div>
            <div className="card-content">
              <h3>{step.title}</h3>
              <p>{step.text}</p>
            </div>
          </Card>
        ))}
      </div>
      <FooterMenu />
    </div>
  );
};

export default MainPage;
